export default "__VITE_ASSET__62cd37ce__"